import React from 'react';

const tabs = [
  { id: 'course', label: 'Kursinnhold' },
  { id: 'facilitator', label: 'Kursledervisning' },
  { id: 'assessment', label: 'Kunnskapstest' }
];

export default function CourseTabs({ activeTab, onChange }) {
  return (
    <div className="flex flex-wrap gap-2 rounded-2xl border border-slate-200 bg-white p-2">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          aria-pressed={activeTab === tab.id}
          className={`rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors ${
            activeTab === tab.id
              ? 'bg-blue-600 text-white'
              : 'text-slate-600 hover:bg-slate-50'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}